document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.wetness-indicator-container-1, .wetness-indicator-container-2');
  if (containers.length === 0) return;

  const updateHeight = () => {
    // Viewport height
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
    // Start filling when the top of the element enters 80% of the bottom of the viewport
    const startPoint = windowHeight * 0.8;
    // Finish filling when the top of the element enters 20% of the top of the viewport
    const endPoint = windowHeight * 0.2;

    containers.forEach(container => {
      // Get the element's position relative to the viewport
      const rect = container.getBoundingClientRect();
      
      // Calculate progress between 0 and 1
      let progress = (startPoint - rect.top) / (startPoint - endPoint);
      
      // Clamp progress between 0 and 1
      progress = Math.max(0, Math.min(1, progress));
      
      // Read the max-height defined in CSS
      const computedStyle = window.getComputedStyle(container);
      const maxHeightPx = parseFloat(computedStyle.getPropertyValue('max-height'));
      
      // Set the height inline based on progress
      if (!isNaN(maxHeightPx)) {
        container.style.height = `${progress * maxHeightPx}px`;
      }
    });
  };

  // Initial check in case it's already in view on load
  updateHeight();

  // Handle scroll events with requestAnimationFrame for performance
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateHeight();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  
  // Also handle resize just in case the max-height changes across breakpoints
  window.addEventListener('resize', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateHeight();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
});
